import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-71a02c45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-footer-nav" }
const _hoisted_2 = { class: "mobile-footer-nav__top-wrapper safe-horizontal-container" }
const _hoisted_3 = { class: "mobile-footer-nav__top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "placeholder-block" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "placeholder-block placeholder-block--important" }, null, -1))
const _hoisted_6 = { class: "mobile-footer-nav__bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentPlaceholders = _resolveComponent("ContentPlaceholders")!
  const _component_PxButton = _resolveComponent("PxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ContentPlaceholders, {
              key: 0,
              class: "mobile-footer-nav-placeholder",
              rounded: ""
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.selectedCategory > 0)
                ? (_openBlock(), _createBlock(_component_PxButton, {
                    key: 0,
                    class: "mobile-footer-nav__back-btn",
                    type: "link",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prev')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("selfAssessment.assessment.prevButton")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_PxButton, {
                class: _normalizeClass([{ 'is-last': _ctx.isLastStep }, "mobile-footer-nav__next-btn"]),
                type: _ctx.nextButtonType,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.nextButtonText) + " ", 1),
                  (_ctx.showNextButtonIcon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(_ctx.nextButtonClass)
                      }, null, 2))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class", "type"])
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.footer.copyright", {
            year: _ctx.currentYear,
          })), 1)
    ])
  ]))
}